import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  client: null,
  quoteId: null,
  callEnded: false, // Nuevo estado para detectar cuando termina la llamada
};

const twilioPhoneSlice = createSlice({
  name: "twilioPhone",
  initialState,
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setData: (state, action) => {
      state.client = action.payload.client;
      state.quoteId = action.payload.quoteId;
    },
    openWithData: (state, action) => {
      state.open = true;
      state.client = action.payload.client;
      state.quoteId = action.payload.quoteId;
      state.callEnded = false; // Resetear cuando se abre una nueva llamada
    },
    close: (state) => {
      state.open = false;
      state.client = null;
      state.quoteId = null;
      state.callEnded = false;
    },
    setCallEnded: (state, action) => {
      state.callEnded = action.payload;
    },
    resetCallEnded: (state) => {
      state.callEnded = false;
    },
  }
});

export const { 
  setOpen, 
  setData, 
  openWithData, 
  close, 
  setCallEnded, 
  resetCallEnded 
} = twilioPhoneSlice.actions;

export default twilioPhoneSlice.reducer; 